module.exports = __webpack_public_path__ + "static/assets/4cef2e3cf3e4dc601b7734151daef29e.svg";